export const isUndefinedOrEmptyObject = (value: any) => value === undefined || JSON.stringify(value) === '{}'
